import { DEFAULT_MAX_SIZE } from "@tfg/ui"
import { useTranslation } from "react-i18next"

import { queryClient } from "~/backend/queryClient"
import { FindIngestionsFiltersDto, findIngestionsQueryKey } from "~/gen/api"
import { ImportDocumentCard } from "~/pages/Brand/DataTransfer/Import/components/ImportDocumentCard"
import { IngestionSortsType } from "~/pages/Brand/DataTransfer/Import/components/IngestionsSorts"
import { usePreImportChecksMutation } from "~/pages/Brand/DataTransfer/Import/hooks/usePreImportChecksMutation"
import { showAxiosError } from "~/utils/showAxiosError"
import { showSuccessNotification } from "~/utils/showSuccessNotification"

type ProductImportLegacyCardProps = {
  href: string
  sorts: IngestionSortsType
  filters: FindIngestionsFiltersDto
}

export const ProductImportLegacyCard = ({
  href,
  sorts,
  filters,
}: ProductImportLegacyCardProps) => {
  const { t } = useTranslation("dataTransfer")

  const { mutate: preImportChecks } = usePreImportChecksMutation({
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: findIngestionsQueryKey({ sorts, filters }),
      })
      showSuccessNotification({
        title: t("upload.success"),
        message: t("upload.success"),
      })
    },
    onError: (error) => {
      showAxiosError({
        notificationTitle: t("upload.error"),
        notificationMessage: error.message,
        showNotification: true,
        error,
      })
    },
  })

  return (
    <ImportDocumentCard
      title={t("import.legacy.templateCard.title")}
      description={t("import.legacy.templateCard.description")}
      uploadButtonProps={{
        tooltip: t("import.legacy.templateCard.uploadButton.tooltip", {
          maxSize: DEFAULT_MAX_SIZE / 1024 ** 2,
        }),
        label: t("import.legacy.templateCard.uploadButton.label"),
      }}
      notificationsProps={{
        erase: t("upload.erase"),
      }}
      areYouSureModalProps={{
        areYouSureText: t("upload.info"),
      }}
      uploadAction={preImportChecks}
      downloadTemplateButtonProps={{
        tooltip: t("import.legacy.templateCard.downloadButton.tooltip"),
        label: t("import.legacy.templateCard.downloadButton.label"),
        href,
      }}
    />
  )
}
